import { useOnline } from '@libs/hooks';
import { isForbidden, isShowChallenge, useAppSelector } from '@libs/store';
import { ConditionalRender } from '@libs/utils';
import React from 'react';
import { ChallengeIframe } from './ChallengeIframe';

export const Challenge: React.FC = () => {
    const statusShowChallenge = useAppSelector(isShowChallenge);
    const statusForbidden = useAppSelector(isForbidden);
    const isOnline = useOnline();

    return (
        <ConditionalRender condition={isOnline && (statusForbidden || statusShowChallenge)}>
            <ChallengeIframe />
        </ConditionalRender>
    );
};
